// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid_peX2q {
  display : grid;
  grid-template-columns: auto 1fr;
  column-gap : var( --size-padMedium, 16px );
  row-gap : var( --size-padMedium, 16px );
  align-items: center;
  justify-content: left;
  padding : var( --size-padMedium, 16px );
}

.fill_iqcQc {
  grid-column: 1 / span 2;
}

.sub__OitR {
  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/type/DetailEditor.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,0CAA0C;EAC1C,uCAAuC;EACvC,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qGAAqG;AACvG","sourcesContent":["\n.grid {\n  display : grid;\n  grid-template-columns: auto 1fr;\n  column-gap : var( --size-padMedium, 16px );\n  row-gap : var( --size-padMedium, 16px );\n  align-items: center;\n  justify-content: left;\n  padding : var( --size-padMedium, 16px );\n}\n\n.fill {\n  grid-column: 1 / span 2;\n}\n\n.sub {\n  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_peX2q`,
	"fill": `fill_iqcQc`,
	"sub": `sub__OitR`
};
export default ___CSS_LOADER_EXPORT___;
